export default __webpack_public_path__ + "static/media/landing-page.c3c2fae3.jpg";